import { NgTemplateOutlet } from "@angular/common";
import { booleanAttribute, ChangeDetectionStrategy, Component, contentChildren, input, model, TemplateRef, viewChild } from "@angular/core";
import { Accordion, AccordionContent, AccordionHeader, AccordionPanel } from "primeng/accordion";

@Component({
    selector: "kno2-accordion-panel",
    template: `
        <ng-template #header>
            <ng-content select="[kno2AccordionHeader]" />
        </ng-template>
        <ng-template #body>
            <ng-content />
        </ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionPanelComponent {
    public readonly value = input.required<string>();
    public readonly headerTemplate = viewChild.required<TemplateRef<unknown>>("header");
    public readonly bodyTemplate = viewChild.required<TemplateRef<unknown>>("body");
}

@Component({
    selector: "kno2-accordion",
    imports: [Accordion, AccordionPanel, AccordionHeader, AccordionContent, NgTemplateOutlet],
    template: `
        <p-accordion
            [value]="value()"
            (valueChange)="value.set($any($event))"
            [multiple]="multiple()">
            @for (panel of panels(); track panel.value()) {
                <p-accordion-panel [value]="panel.value()">
                    <p-accordion-header>
                        <ng-container [ngTemplateOutlet]="panel.headerTemplate()" />
                    </p-accordion-header>
                    <p-accordion-content>
                        <ng-container [ngTemplateOutlet]="panel.bodyTemplate()" />
                    </p-accordion-content>
                </p-accordion-panel>
            }
        </p-accordion>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionComponent {
    public readonly value = model<string | string[]>();
    public readonly multiple = input<boolean, unknown>(false, { transform: booleanAttribute });
    public readonly panels = contentChildren(AccordionPanelComponent);
}
